export default __webpack_public_path__ + "static/media/emef_landingpage_bg.e334f985.jpg";